import React from 'react';
import { Grid, Box, Button } from '@material-ui/core';
import { TB_PORTAL_SCHOOL_UPDATE_ROUTE } from '../../../../routes/routes';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const BranchViewDetailsHeader = ({ styles, data }) => {
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Box
            fontSize={24}
            fontWeight={500}
            fontFamily={'Rubik'}
            mt={1}
            mb={2}>
            {data ? (
              <Box display="flex" flexDirection="row">
                {data.name}
              </Box>
            ) : (
              'View School Details'
            )}
          </Box>
          <div className={styles.subHeadingText}>
            Update your school information
          </div>
        </Grid>
        <Grid item xs={4}>
          <div style={{ float: 'right' }}>
            <Link to={`/teenybeans-portal`}>
              <Button
                variant="outlined"
                disableElevation
                size="large"
                color="primary">
                Back
              </Button>
            </Link>
            &nbsp;&nbsp;
            <Link
              to={`${TB_PORTAL_SCHOOL_UPDATE_ROUTE}?schoolId=${
                data && data._id
              }`}>
              <Button
                variant="contained"
                disableElevation
                size="large"
                color="primary">
                Edit
              </Button>
            </Link>
          </div>
        </Grid>
      </Grid>
      <Box
        mt={3}
        mb={2}
        fontFamily="Rubik"
        display="flex"
        justifyContent="space-between">
        <Box>
          {/* <Box fontSize={18} fontWeight={'fontWeightMedium'} mb={1}>
            Your School Information
          </Box> */}
          <Box maxWidth={640} fontSize={14}>
            Fill up the information about the school that partners would be able
            to see on Teeny Beans Partner Portal.
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default BranchViewDetailsHeader;
